// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"766":"26cf532f","787":"5ddfd2ad","919":"68485557"}[chunkId] + ".chunk.js";
};